<template>
  <div class="corona--graph">
    <h2>Sjukhusvårdade i Finland</h2>
    <h3>Uppdaterad <span v-if="updated">{{ this.updated }}</span> | Källa: <a href="https://thl.fi/fi/web/infektiotaudit-ja-rokotukset/ajankohtaista/ajankohtaista-koronaviruksesta-covid-19/tilannekatsaus-koronaviruksesta" aria-label="Statistikens källa THL">THL</a></h3>
    <HospitalInfo v-if="data" :data="data.data['Yhteensä koko maa']" />
    <HospitalChart />
    <p><small>Uppgifterna uppdateras på vardagar. Före 7 december har informationen om avdelningsvårdade patienter på stads- och hälsocentralsjukhus varit ofullständig.</small></p>
    <p>
      I tabellen ser du hur många patienter som just nu vårdas i universitets&shy;sjukhusens specialupptagnings&shy;områden.
    </p>
    <table class="corona--table">
      <thead>
        <tr>
          <th>Område</th>
          <th>Avdelningsvård</th>
          <th>Intensivvård</th>
        </tr>
      </thead>
      <tbody v-if="data">
        <tr v-for="district in districts" :key="district.id">
          <td>{{ district.name_sv }}</td>
          <td>{{ data.data[district.name_fi].osastohoito }}</td>
          <td>{{ data.data[district.name_fi].tehohoito }}</td>
        </tr>
      </tbody>
    </table>
    <h2>Dödsfall orsakade av covid-19</h2>
    <p>
      Sammanlagt har
      <strong v-if="data">{{ data.data['Yhteensä koko maa'].kuolleetkum }}</strong>
      <strong v-else>…</strong>
      personer avlidit i Finland. I grafen ser du när dödsfallen har inträffat.
    </p>
    <DeathsChart />
  </div>
</template>

<script>
import 'unfetch/polyfill'

import HospitalInfo from './HospitalInfo'
import HospitalChart from './HospitalChart'
import DeathsChart from './DeathsChart'

import districts from './specialDistricts.json'

export default {
  name: 'HospitalMap',
  data() {
    return {
      error: false,
      data: null,
      districts,
    }
  },
  components: {
    HospitalInfo,
    HospitalChart,
    DeathsChart,
  },
  created() {
    fetch((process.env.NODE_ENV === 'production' ? 'https://svenska-dataviz.ylestatic.fi/2020-03-corona/' : 'http://local.yle.fi:8080/data/') + 'data-hospitalized-new.json', {cache: 'no-store'})
      .then((response) => response.json())
      .then((data) => {
        this.data = data;
      })
      .catch((error) => {
        this.error = error;
      });
  },
  destroyed () {
  },
  methods: {
  },
  computed: {
    updated() {
      if (this.data) {
        const time = new Date(this.data.timestamp);
        const date = `${time.getDate()}.${time.getMonth() + 1}.${time.getFullYear()}`;
        return date;
      }
      else return null;
    },
  },
}
</script>

<style lang="scss" scoped>
.corona--map {
  max-width: 420px;
  margin: 0 auto;
  display: block;
}
</style>